export default "__VITE_ASSET__B0tjORGP__"